import { Controller } from '@hotwired/stimulus'

export default class extends Controller<HTMLDetailsElement> {
  open (): void {
    this.element.open = true
  }

  reveal (): void {
    requestAnimationFrame(() => {
      if (this.element.open) this.element.scrollIntoView({ block: 'start' })
    })
  }
}
